export const formatFlag = (flag) => {
  return `${process.env.NODE_ENV}_${flag}`;
};
